module.exports = __webpack_public_path__ + "static/stormproof-window-91829f8fb4746f29d3c5a3ed3791635c.jpg";